import { render, staticRenderFns } from "./EditModules.vue?vue&type=template&id=b4940660"
import script from "./EditModules.vue?vue&type=script&lang=js"
export * from "./EditModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports